export default __webpack_public_path__ + "static/media/jts_alabang.dead3817.webp";